
import { useTranslation } from 'react-i18next';
import { Search, Cpu, Code, Rocket, HeartHandshake } from 'lucide-react';
import Section from '../ui/Section';
import SectionHeader from '../ui/SectionHeader';

const Process = () => {
  const { t } = useTranslation();
  
  const steps = [
    {
      key: 'step1',
      icon: <Search className="w-6 h-6" />,
      color: 'text-blue-400',
      bgColor: 'bg-blue-500/20',
      borderColor: 'border-blue-500/50',
    },
    {
      key: 'step2',
      icon: <Cpu className="w-6 h-6" />,
      color: 'text-purple-400',
      bgColor: 'bg-purple-500/20',
      borderColor: 'border-purple-500/50',
    },
    {
      key: 'step3',
      icon: <Code className="w-6 h-6" />,
      color: 'text-emerald-400',
      bgColor: 'bg-emerald-500/20',
      borderColor: 'border-emerald-500/50',
    },
    {
      key: 'step4',
      icon: <Rocket className="w-6 h-6" />,
      color: 'text-orange-400',
      bgColor: 'bg-orange-500/20',
      borderColor: 'border-orange-500/50',
    },
    {
      key: 'step5',
      icon: <HeartHandshake className="w-6 h-6" />,
      color: 'text-pink-400',
      bgColor: 'bg-pink-500/20',
      borderColor: 'border-pink-500/50',
    },
  ];
  
  return (
    <Section id="process" background="default">
      <SectionHeader
        title={t('process.title')}
        subtitle={t('process.subtitle')}
      />
      
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-5 gap-6 md:gap-4">
          {steps.map((step, index) => (
            <div
              key={step.key}
              className="relative group"
            >
              {/* Connector line - only show on desktop between cards */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-16 left-full w-4 h-0.5 bg-gradient-to-r from-primary/50 to-transparent z-0" />
              )}
              
              <div className="relative z-10">
                {/* Icon with number */}
                <div className="flex flex-col items-center mb-4">
                  <div className={`w-20 h-20 rounded-xl bg-gradient-to-br ${step.bgColor} border ${step.borderColor} flex items-center justify-center ${step.color} group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 shadow-lg group-hover:shadow-xl`}>
                    {step.icon}
                  </div>
                  <div className="mt-3 w-8 h-8 rounded-full bg-primary flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300">
                    <span className="text-sm font-bold text-background">{index + 1}</span>
                  </div>
                </div>
                
                {/* Content */}
                <div className="text-center">
                  <h3 className="text-base font-heading font-bold text-white mb-2 group-hover:text-primary transition-colors">
                    {t(`process.${step.key}.title`)}
                  </h3>
                  
                  <p className="text-sm text-gray-400 leading-relaxed group-hover:text-gray-300 transition-colors">
                    {t(`process.${step.key}.description`)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default Process;
